import { useParams } from "react-router-dom";
import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";
import client from "../../../feathers"
import { useEffect, useState } from "react";

const CarClassicContainer = () => {
  const { id } = useParams();
  const [ data, setData ] = useState<any>({})
  
  const fetchData = (id: string) => {
    return client.service('products').get(id)
    .then((res: any) => {
      setData(res)
    })
    .catch((err: any)=>{
      console.log(err)
    })
  }

  useEffect(() => {
    if(id){
      fetchData(id)
    }
  }, [id])

  return (
    <>
      <CarBreadcrumb type="car_detail" data={data} detailImages mailClass="car-breadcrumbs-section page-breadcrumbs-section-inventory" />
      <CarDetail type="car" data={data} detailImages />
    </>
  );
};

export default CarClassicContainer;
